import styled from 'styled-components'

export const StyledImg = styled.img`
  display: block;
  user-select: none;
`
